export default __webpack_public_path__ + "images/b0b5d5504a6cd68b8524234f9b5b0fe4.svg";